import { AuthLayout, VerifyEmail } from "../components/authComponents"

function VerifyEmailPage(props) {
    const { token } = props.match.params;
    return (
        <AuthLayout>
            <VerifyEmail token={token} />
        </AuthLayout>
    );
}

export default VerifyEmailPage;